module.exports = __webpack_public_path__ + "img/inAppPayment.1dbcf1fa.png";